function queryViewport() {

    const viewportTestEl = window.getComputedStyle(document.querySelector('.detect-viewport'));

    return {
        "40px": 'xl',
        "30px": 'lg',
        "20px": 'md',
        "10px": 'sm',
        "1px": 'xs',
    }[viewportTestEl.marginTop]

}

const viewportTestElement = document.createElement('div');
viewportTestElement.classList.add('detect-viewport');
document.querySelector('body').appendChild(viewportTestElement);